<p-tabs [value]="initialIndex">
  <p-tablist>
    @if (artifact.data['emailContent']['htmlBody']) {
      <p-tab [value]="0">Html Body</p-tab>
    }
    @if (artifact.data['emailContent']['txtBody']) {
      <p-tab [value]="1">Text Body</p-tab>
    }
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <wm-mailcontent-artifact-mail-details
              [from]="artifact.data['from']"
              [to]="artifact.data['to']"
              [subject]="artifact.data['emailContent']['subject']"
              [body]="artifact.data['emailContent']['htmlBody']"
              [hasHtmlBody]="true"
              [sentDate]="artifact.creationTime"
      >
      </wm-mailcontent-artifact-mail-details>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <wm-mailcontent-artifact-mail-details
              [from]="artifact.data['from']"
              [to]="artifact.data['to']"
              [subject]="artifact.data['emailContent']['subject']"
              [body]="artifact.data['emailContent']['txtBody']"
              [sentDate]="artifact.creationTime"
      >
      </wm-mailcontent-artifact-mail-details>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
